import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LogicStepDefinition, LogicStepType } from '@wdx/shared/swagger-gen';
import { WorkflowLogicStepDef } from '../../models';

@Component({
    selector: 'clmi-workflow-designer-steps',
    templateUrl: './workflow-designer-steps.component.html',
    styleUrl: './workflow-designer-steps.component.scss',
    standalone: false,
})
export class WorkflowDesignerStepsComponent {
    @Input() steps: {
        type: LogicStepType;
        steps: WorkflowLogicStepDef[];
    }[];
    @Output() stepClicked = new EventEmitter<LogicStepDefinition>();

    onStepClicked(stepDef: LogicStepDefinition) {
        this.stepClicked.emit(stepDef);
    }

    getTypeTranslationKey(type: LogicStepType) {
        return `ENUM_LOGICSTEPTYPE_${type.toUpperCase()}`;
    }
}
